import { Component, OnInit, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { CallCenterService } from "src/app/services/call-center.service";
import { CommonService } from "src/app/services/common.service";
import { CommonMethods } from "src/app/shared/CommonMethods";
import { Subscription } from "rxjs";
import { AskApolloService } from "src/app/services/ask-apollo.service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MessageServiceService } from "src/app/services/message-service.service";
import { AttachSession } from "protractor/built/driverProviders";
import { CalendarUtilityService } from "src/app/services/calendar-utility.service";
import { ItdoseService } from "src/app/services/itdose.service";
import { CitiesList, specialityData } from "src/app/models/common-model";
import { Console } from "console";
import { SelectItem } from "primeng/api";
import { delay } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { ActivityService } from "src/app/services/activity.service";
@Component({
  selector: "app-create-appointment-dialog",
  templateUrl: "./create-appointment-dialog.component.html",
  styleUrls: ["./create-appointment-dialog.component.scss"],
})
export class CreateAppointmentDialogComponent implements OnInit, OnDestroy {
  selectedUHIDDetails: any;
  isNewUser: boolean = false;
  callType: number;
  loadingFlag: boolean = false;
  submitted: boolean;
  yearRange = `${new Date().getFullYear()}:${new Date().getFullYear() + 30}`;

  resetPkgEnquiryForm: boolean;
  countryCode: string = "+91";

  //objects
  citiesData: any[];
  clinicsData: any[];
  specialitiesData: any[];
  doctorsData: any[];
  datesData: any[];
  slotsData: any = {};
  apptRequestModes: any[];
  //rescheduleDetails:any[];
  isAppointmentCreatedSuccessfully = false;
  callerStatusAutoId = 0;
  callerId;
  isSelectedCallBackOption = false;
  isInboundCallNewUser = false;
  isSelectedStatusUpdate = false;
  isSelectedAppointment = false;
  isCallBackLater = false;
  selectedCallStatusName;
  selectedCallStatusId;
  selectedAppointmentType = 1;
  selectedHospitalType = 2;
  selectedCity;
  selectedHospital;
  selectedSpeciality;
  selectedDoctor;
  selectedDate;
  minDate = new Date();
  yearRangeDob = "";
  dobMaxDate: Date;
  callBackMinimumDate = new Date();
  DispositionData: Subscription;
  googlePlaces = [];
  address: string;
  locationDetails: any;
  countries: any[];
  selectedCountry: string;
  data: any;
  monthLabels: any;
  areaCode: any[];
  selectedPincode: string;
  selectedPincodeDate: string;
  currentUser: any;
  appointmentData: any;
  countryCodes: any;
  appointmentTypeId: any = 1;
  isAppointmentType: boolean = false;
  citySub: Subscription;
  cities: CitiesList[];

  constructor(
    private callCenterService: CallCenterService,
    private messageService: MessageServiceService,
    private askApolloService: AskApolloService,
    private formBuilder: FormBuilder,
    private ref: ChangeDetectorRef,
    private calendarService: CalendarUtilityService,
    private commonService: CommonService,
    private ITDoseService: ItdoseService,
    private activityService: ActivityService
  ) {
    this.countryCodes = [];

    let date = new Date();
    this.dobMaxDate = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate() - 1
    );
    this.yearRangeDob = `${date.getFullYear() - 100}:${date.getFullYear()}`;
  }
  createAppointmentForm: FormGroup;
  callStatusForm: FormGroup;
  currentUserBU: string;
  configValuesList: any[];
  IsThirdPartyIntegration;

  ngOnInit() {
    debugger;
    this.IsThirdPartyIntegration =
      this.askApolloService.getIntegrationValueFromLocalStorage();

    var configvalues = localStorage.getItem("generalconfig");
    if (configvalues !== null) {
      this.configValuesList = JSON.parse(configvalues);
      const entry = this.configValuesList.find((c) => c.keyName === "IsOnline");
      if (entry.keyValue == "1") {
        this.isAppointmentType = true;
      }
    }

    //this.messageService.showSuccess("test");
    this.selectedPincodeDate = this.selectedPincodeDate
      ? this.selectedPincodeDate
      : "";
    this.getAllCities(this.selectedAppointmentType);
    this.getApptRequestModes();

    this.currentUser = JSON.parse(
      localStorage.getItem("CurrentOutBoundCallMobileNumber")
    );
    this.appointmentData = JSON.parse(
      localStorage.getItem("AppointmentInformation")
    );
    console.log("apt", this.appointmentData);

    const lastAppointment =
      this.appointmentData == null
        ? undefined
        : this.appointmentData[this.appointmentData.length - 1];
    console.log("kl", lastAppointment);
    debugger;

    this.createAppointmentForm = this.formBuilder.group({
      patientFirstName: ["", Validators.required],
      patientLastName: ["", Validators.required],
      dateOfBirth: [null, Validators.required],
      gender: ["", [Validators.required, Validators.min(1)]],
      maritalStatusId: ["", Validators.required],
      relationTypeId: ["", Validators.required],
      salutation: [""],
      email: [
        "",
        [
          Validators.required,
          Validators.pattern(
            /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/
          ),
        ],
      ],
      countryCode: ["91", [Validators.required]],
      patientMobileNumber: ["", [Validators.required]],
      mobileNumber: [
        "",
        [Validators.required, Validators.pattern(/^[0-9]{9,10}$/)],
      ],
      city: ["", [Validators.required, Validators.min(1)]],
      clinic: ["", [Validators.required, Validators.min(1)]],
      speciality: ["", [Validators.required, Validators.min(1)]],
      doctor: ["", [Validators.required, Validators.min(1)]],
      appointmentDate: ["", ""], //["", Validators.required],
      appointmentSlot: ["", ""], //["", [Validators.required, Validators.min(1)]],
      appointmentReqMode: ["", [Validators.required, Validators.min(1)]],
      statusRemarks: [""],
    });

    let formData = {};
    if (this.appointmentData !== null) {
      // Check if UpcomingAppointments exists and has items
      if (
        this.appointmentData.UpcomingAppointments &&
        this.appointmentData.UpcomingAppointments.length > 0
      ) {
        // Get the last record from UpcomingAppointments
        formData =
          this.appointmentData.UpcomingAppointments[
            this.appointmentData.UpcomingAppointments.length - 1
          ];
        console.log("Using last upcoming appointment:", formData);
      } else if (
        this.appointmentData.PastAppointments &&
        this.appointmentData.PastAppointments.length > 0
      ) {
        formData =
          this.appointmentData.PastAppointments[
            this.appointmentData.PastAppointments.length - 1
          ];
        console.log("Using last past appointment:", formData);
      } else {
        console.log(
          "No appointment data found in either array, using empty object"
        );
        formData = {};
      }
    }
    debugger;
    console.log("formdata", formData);
    const cityId =
      formData["cityId"] && formData["cityId"] !== 0
        ? formData["cityId"]
        : formData["city_IdStr"] || null;

    const specialtyId =
      formData["specialtyId"] && formData["specialtyId"] !== 0
        ? formData["specialtyId"]
        : Number(formData["specialty_IdStr"]) || null;

    const doctorId =
      formData["doctorId"] && formData["doctorId"] !== 0
        ? formData["doctorId"]
        : Number(formData["doctor_IdStr"]) || null;

    const AppointmentDate = formData["appointmentDate"];
    // formData["appointmentDate"] && formData["appointmentDate"] !== 0
    //   ? formData["appointmentDate"]
    //   : Number(formData["appointmentDate"]) || null;

    this.getClinicsOnCityId(cityId);
    this.getSpecialities(formData["hospitalId"]);
    this.getDoctors(specialtyId);
    this.getDates(doctorId);
    this.getSlots(this.parseDateFromDDMMYYYY(AppointmentDate));

    // this.getSlots(formData["appointmentDate"])

    if (this.currentUser == null || this.currentUser == undefined) {
      // this.getClinicsOnCityId(this.appointmentData[0]["cityId"]);
      // this.getSpecialities(this.appointmentData[0]["hospitalId"]);
      // this.getDoctors(this.appointmentData[0]["specialtyId"]);
      // this.getDates(this.appointmentData[0]["doctorId"]);

      this.createAppointmentForm = this.formBuilder.group({
        patientFirstName: ["", Validators.required],
        patientLastName: ["", Validators.required],
        dateOfBirth: ["", Validators.required],
        gender: ["", [Validators.required, Validators.min(1)]],
        maritalStatusId: ["", Validators.required],
        relationTypeId: ["", Validators.required],
        salutation: ["", [Validators.required, Validators.min(1)]],
        email: [
          "",
          [
            Validators.required,
            Validators.pattern(
              /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/
            ),
          ],
        ],
        countryCode: ["91", [Validators.required]],
        patientMobileNumber: ["", [Validators.required]],
        mobileNumber: [
          "",
          [Validators.required, Validators.pattern(/^[0-9]{9,10}$/)],
        ],
        city: ["", [Validators.required, Validators.min(1)]],
        areaPincode: ["500033"],
        clinic: ["", [Validators.required, Validators.min(1)]],
        speciality: ["", [Validators.required, Validators.min(1)]],
        doctor: ["", [Validators.required, Validators.min(1)]],
        appointmentDate: ["", ""], //["", Validators.required],
        appointmentSlot: ["", ""], //["", [Validators.required, Validators.min(1)]],
        appointmentReqMode: ["", [Validators.required, Validators.min(1)]],
        statusRemarks: [""],
      });
    } else {
      this.currentUserBU = JSON.parse(
        localStorage.getItem("LOGGED_USER_INFO")
      ).bussinessUnitName;
      debugger;
      if (formData["patientFirstName"] !== undefined) {
        this.createAppointmentForm = this.formBuilder.group({
          patientFirstName: [formData["patientFirstName"], Validators.required],
          patientLastName: [formData["patientLastName"], Validators.required],
          dateOfBirth: [
            this.parseDateFromDDMMYYYY(formData["dateOfBirth"]),
            Validators.required,
          ],
          gender: [
            formData["genderId"].toString(),
            [Validators.required, Validators.min(1)],
          ],
          maritalStatusId: ["1", Validators.required],
          relationTypeId: ["1", Validators.required],
          salutation: ["1", [Validators.required, Validators.min(1)]],
          email: [
            formData["emailId"],
            [
              Validators.required,
              Validators.pattern(
                /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/
              ),
            ],
          ],
          countryCode: [formData["countryCode"]],
          patientMobileNumber:
            formData["countryCode"] == "971"
              ? [
                  formData["mobileNumber"].slice(
                    formData["mobileNumber"].length - 9
                  ),
                  [Validators.required, Validators.pattern(/^[0-9]{9,9}$/)],
                ]
              : [
                  formData["mobileNumber"].slice(
                    formData["mobileNumber"].length - 10
                  ),
                  [Validators.required, Validators.pattern(/^[0-9]{9,10}$/)],
                ],
          mobileNumber:
            formData["countryCode"] == "971"
              ? [
                  formData["patientMobileNumber"].slice(
                    formData["patientMobileNumber"].length - 9
                  ),

                  [Validators.required, Validators.pattern(/^[0-9]{9,9}$/)],
                ]
              : [
                  formData["patientMobileNumber"].slice(
                    formData["patientMobileNumber"].length - 10
                  ),

                  [Validators.required, Validators.pattern(/^[0-9]{9,10}$/)],
                ],
          city: [cityId, [Validators.required, Validators.min(1)]],
          areaPincode: ["500033"],
          clinic: [
            formData["hospitalId"],
            [Validators.required, Validators.min(1)],
          ],
          speciality: [specialtyId, [Validators.required, Validators.min(1)]],
          doctor: [doctorId, [Validators.required, Validators.min(1)]],
          appointmentDate: [new Date(), Validators.required], //["", Validators.required],
          appointmentSlot: ["", ""], //["", [Validators.required, Validators.min(1)]],
          appointmentReqMode: ["", [Validators.required, Validators.min(1)]],
          statusRemarks: [""],
        });
      }
      console.log("cityId", cityId);

      this.selectedAreaPincode = "500033";
      console.log("aptdate", formData["appointmentDate"]);
      //this.appointmentData[0]["doctorId"] , this.appointmentData[0]["specialtyId"],this.parseDate(this.appointmentData[0]["appointmentDate"]),this.appointmentData[0]["slotTime"]
      //this.appointmentData[0]["slotTime"], this.appointmentData[0]["cityId"], this.appointmentData[0]["appointmentRequestModeName"]
      //this.parseDate(this.appointmentData[0]["dateOfBirth"])
    }

    debugger;

    this.callStatusForm = this.formBuilder.group({
      callBackDate: [""],
      callBackTime: [""],
      remarks: ["", Validators.required],
      subDisposition: ["", [Validators.required, Validators.min(1)]],
      city: ["", [Validators.required, Validators.min(-1)]],
      clinic: ["", [Validators.required, Validators.min(-1)]],
      speciality: ["", [Validators.required, Validators.min(-2)]],
      doctor: ["", [Validators.required, Validators.min(-1)]],
      area: ["", [Validators.required]],
      scheduleDate: ["", [Validators.required]],
    });

    if (this.currentUserBU == "Diagnostics") {
      this.callStatusForm.get("clinic").disable();
      this.callStatusForm.get("speciality").disable();
      this.callStatusForm.get("doctor").disable();
    } else {
      this.callStatusForm.get("area").disable();
    }

    if (!this.isCallBackLater) {
      this.callStatusForm.get("scheduleDate").disable();
    }
    debugger;

    this.CheckPrimaryCases();
    debugger;
    if (localStorage.getItem("CurrentOutBoundCallMobileNumber") != null) {
      var leadObject: any = localStorage.getItem(
        "CurrentOutBoundCallMobileNumber"
      );
      var leadmodel: any = JSON.parse(leadObject);
      this.leadId = leadmodel.leadId;
    }
    //this.getAreaPincode();
    console.log("test");
    this.citySub = this.activityService.cities
      .pipe(delay(0))
      .subscribe((cities) => {
        this.cities = cities;
        console.log("cities", this.cities);
      });
    // this.activityService.getApprovedActivities().subscribe((data: any) => {
    //   this.activities = data.result;
    // });
  }

  ngAfterViewInit() {
    this.commonService
      .getCountryCodes()
      .pipe(delay(0))
      .subscribe((codes) => {
        console.log("Fetched Country Codes:", codes); // Debugging log to ensure data is fetched

        this.countryCodes = [];
        Object.keys(codes).forEach((key) => {
          this.countryCodes.push(codes[key]);
        });
      });
  }
  ngOnDestroy() {
    this.DispositionData.unsubscribe();
    this.citySub.unsubscribe();
  }

  get isThirdPartyIntegrationNumber(): number {
  return Number(this.IsThirdPartyIntegration);
}

  OnChange(ev) {
    //console.log("text", ev.originalEvent.target.innerText)
    console.log("test", ev);
    this.selectedPincodeDate = ev.originalEvent.target.innerText;
  }
  parseDateFromDDMMYYYY(dateStr: string): Date | null {
    console.log("Original date string:", dateStr);

    if (!dateStr || typeof dateStr !== "string") {
      console.log("Invalid input");
      return null;
    }

    try {
      // Remove time part if present
      let datePart = dateStr.trim().split(" ")[0];

      // Handle pure YYYYMMDD format
      const yyyymmddMatch = datePart.match(/^(\d{4})(\d{2})(\d{2})$/);
      if (yyyymmddMatch) {
        const [, year, month, day] = yyyymmddMatch.map(Number);
        const date = new Date(year, month - 1, day);
        if (!isNaN(date.getTime())) {
          console.log("Parsed as YYYYMMDD:", date);
          return date;
        }
      }

      // Detect separator
      const separator = datePart.includes("/")
        ? "/"
        : datePart.includes("-")
        ? "-"
        : null;

      if (!separator) {
        console.log("Unrecognized date separator");
        return null;
      }

      const parts = datePart.split(separator).map((p) => parseInt(p, 10));

      if (parts.length !== 3 || parts.some(isNaN)) {
        console.log("Date must have 3 numeric parts");
        return null;
      }

      const [p1, p2, p3] = parts;

      // Try DD/MM/YYYY
      const tryDate = (
        day: number,
        month: number,
        year: number
      ): Date | null => {
        const date = new Date(year, month - 1, day);
        return date.getDate() === day &&
          date.getMonth() === month - 1 &&
          date.getFullYear() === year
          ? date
          : null;
      };

      // Try all common orders
      let date =
        tryDate(p1, p2, p3) || // DD/MM/YYYY
        tryDate(p2, p1, p3) || // MM/DD/YYYY
        tryDate(p3, p2, p1); // YYYY/MM/DD or YYYY-MM-DD

      if (date) {
        console.log("Parsed as flexible format:", date);
        return date;
      }

      console.log("Could not parse date with any format");
      return null;
    } catch (err) {
      console.error("Error parsing date:", err);
      return null;
    }
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.createAppointmentForm.controls[controlName];
    if (!control) {
      return false;
    }
    // console.log(
    //   `Checking error for: ${controlName}, Type: ${validationType}`,
    //   control.errors
    // );

    return (
      control.hasError(validationType) && (control.dirty || control.touched)
    );
  }

  mobileValidator(control: any) {
    const countryCode = this.createAppointmentForm.get("countryCode").value; // Get the country code from the form

    let regex;

    // Define validation patterns based on the country code
    if (countryCode === "91") {
      // India
      regex = /^[0-9]{10}$/; // 10 digits for India
    } else if (countryCode === "971") {
      // UAE
      regex = /^[0-9]{9}$/; // 9 digits for UAE
    } else {
      regex = /^[0-9]{9,10}$/; // Default for other countries
    }

    // If the value exists, test against the regex
    if (control.value && !regex.test(control.value)) {
      return { invalidMobile: true }; // Invalid mobile number
    }

    return null; // Valid mobile number
  }

  // onCountryCodeChange() {
  //   const countryCode = this.createAppointmentForm.get("countryCode").value;

  //   // Update the validator dynamically
  //   const mobileControl = this.createAppointmentForm.get("patientMobileNumber");
  //   mobileControl.setValidators([
  //     Validators.required,
  //     this.mobileValidator.bind(this),
  //   ]);
  //   mobileControl.updateValueAndValidity();

  //   const altMobileControl = this.createAppointmentForm.get("mobileNumber");
  //   altMobileControl.setValidators([
  //     Validators.required,
  //     this.mobileValidator.bind(this),
  //   ]);
  //   altMobileControl.updateValueAndValidity();
  // }
  onCountryCodeChange(event: Event): void {
    const selectedCode = (event.target as HTMLSelectElement).value;
    console.log("Selected country code:", selectedCode);

    const phoneControl = this.createAppointmentForm.get("patientMobileNumber");

    if (!phoneControl) return;

    // Clear previous validators
    phoneControl.clearValidators();

    // Set validators based on country code
    if (selectedCode === "971") {
      // UAE: mobile number must start with 5 and be 9 digits
      phoneControl.setValidators([
        Validators.required,
        Validators.pattern(/^5\d{8}$/), // Starts with 5, followed by 8 digits
      ]);
    } else if (selectedCode === "91") {
      // India: mobile number must start with 6-9 and have 10 digits
      phoneControl.setValidators([
        Validators.required,
        Validators.pattern(/^[6-9]\d{9}$/), // Starts with 6-9, followed by 9 digits
      ]);
    } else {
      // Default fallback validator: just digits, 9–10 characters
      phoneControl.setValidators([
        Validators.required,
        Validators.pattern(/^\d{9,10}$/), // Just digits, 9–10 characters
      ]);
    }

    // Re-run validation after updating validators
    phoneControl.updateValueAndValidity();

    // Optional: Log the errors to check for debugging
    console.log("Phone Control Errors:", phoneControl.errors);
  }

  setCountryCode(code: string) {
    this.countryCode = " +" + code;
    this.createAppointmentForm.get("countryCode").setValue(code);
    this.updatePhoneConstraints(); // Update constraints when country code changes
  }

  updatePhoneConstraints() {
    const countryCode = this.createAppointmentForm.get("countryCode").value;
    const phoneControl = this.createAppointmentForm.get("patientMobileNumber");

    // Clear previous value to avoid conflicts
    phoneControl.setValue("");

    // Update validators dynamically
    if (countryCode === "971") {
      phoneControl.setValidators([
        Validators.required,
        Validators.pattern(/^[5-9][0-9]{8}$/),
      ]);
    } else if (countryCode === "91") {
      phoneControl.setValidators([
        Validators.required,
        Validators.pattern(/^[6-9][0-9]{9}$/),
      ]);
    } else {
      phoneControl.setValidators([Validators.required]);
    }

    phoneControl.updateValueAndValidity();
  }

  formatToDateString(date: any): string | null {
    if (!date) return null;
    const d = new Date(date);
    if (isNaN(d.getTime())) return null;

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  leadId: any;
  CheckPrimaryCases() {
    debugger;

    //this method get the selected call status data from service
    this.DispositionData = this.callCenterService.selectedCallStatus.subscribe(
      (value) => {
        debugger;
        this.leadId = value.LeadId;
        this.isNewUser = value.IsNewUser;
        this.callType = value.CallTypeId;
        this.callerStatusAutoId = value.CallerStatusAutoId;
        this.callerId = value.CallerId;
        this.selectedUHIDDetails = value.UHIDDetails;
        // this.rescheduleDetails = value.RescheduleDetails;
        this.selectedCallStatusId = value.CallStatus["callCenterStatusId"];
        this.selectedCallStatusName = value.CallStatus["statusName"];
        if (
          this.selectedCallStatusId == 15 &&
          this.callType == 1 &&
          this.isNewUser
        ) {
          // inbound new user + create appt
          this.isSelectedAppointment = true;
          this.isInboundCallNewUser = true;
          this.loadBasicDetailsOfLead();
        } else if (this.selectedCallStatusId == 15) {
          //outbound+inbound existed user or new user.
          this.isSelectedAppointment = true;
          this.isInboundCallNewUser = false;
          if (this.isNewUser && this.callType == 2) {
            // for lead new user in outbound call only
            this.loadBasicDetailsOfLead();
          } else {
            this.loadBasicDetails();
          }
          this.getAllCities(this.selectedAppointmentType);
        } else if (this.selectedCallStatusId == 16) {
          // outbound + inbound rescheduling
          //console.log("reschedule:", this.rescheduleDetails);
        } else if (this.selectedCallStatusId != 15) {
          this.isSelectedAppointment = false;

          this.isSelectedStatusUpdate = true;
          if (this.selectedCallStatusId == 25) {
            this.isSelectedCallBackOption = true;
            this.callStatusForm
              .get("callBackDate")
              .setValidators(Validators.required);
            this.callStatusForm
              .get("callBackTime")
              .setValidators(Validators.required);
          }
          this.getSubDispositionsData();
        }
        //load appt reuqest modes
        // this.getApptRequestModes(); //old
        this.getAllLeadSources();
      }
    );
  }

  DispositionBU(index, item) {
    return item.name;
  }

  subDispositionsData = [];
  getSubDispositionsData() {
    this.loadingFlag = true;
    this.commonService
      .FetchAllDiagnosticSubDispositions(
        this.selectedCallStatusId,
        this.currentUserBU
      )
      .subscribe(
        (res: any) => {
          if (res && res.response && res.response.length > 0) {
            // console.log("dis", res);
            this.subDispositionsData = res.response;
          } else {
            this.subDispositionsData = [];
          }
          this.getAllCities(this.selectedAppointmentType);
          this.loadingFlag = false;
        },
        (error) => {
          this.messageService.showErrorMessage(
            "Unable to retrieve sub dispositions data from server "
          );
        }
      );
  }

  getSubDispositionStatus(event) {
    //console.log("Testing", event)
    if (this.currentUserBU != "Dialysis") {
      if (event === "29") {
        this.isCallBackLater = true;
        this.callStatusForm.get("scheduleDate").enable();
      }
    }
  }

  search(event) {
    //when user type the location name immediately fetches the location suggestions.
    this.loadingFlag = true;
    let search = event.query;
    this.ITDoseService.getGoogleLocations(search).subscribe(
      (res: any) => {
        if (res.response) {
          this.googlePlaces = res.response;
        } else {
          this.googlePlaces = [];
          this.messageService.showErrorMessage("No places found");
        }
        this.loadingFlag = false;
      },
      (error) => {
        this.messageService.showError();
      }
    );
  }
  areaSearch(event) {
    //when user type the location name immediately fetches the location suggestions.
    let search = event.query;
    if (search.length >= 3) {
      this.loadingFlag = true;
      this.callCenterService.getAllAreaPincode(search).subscribe(
        (res: any) => {
          if (res.response) {
            this.filterCountry(res.response);
          } else {
            this.filteredAreaData = [];
            this.messageService.showErrorMessage("No Area found");
          }
          this.loadingFlag = false;
        },
        (error) => {
          this.messageService.showError();
        }
      );
    }
  }
  filteredAreaData: any[];
  selectedAreaPincode: string = "Select Pincode";
  selectedArea: string;
  filterCountry(event) {
    //in a real application, make a request to a remote url with the query and return filtered results, for demo we filter at client side
    let filteredArea: any[] = [];
    for (let i = 0; i < event.length; i++) {
      let country = event[i];
      filteredArea.push(country.area + " - " + country.pincode);
    }
    this.filteredAreaData = filteredArea;
  }
  onSelectArea(event) {
    this.selectedAreaPincode = event.slice(-6);
    this.selectedArea = event.slice(0, -9);
  }

  onSelect(event) {
    debugger;
    //when user selects the location from the dopdown will get the longitude & latitude details
    this.loadingFlag = true;
    this.address = event;
    this.ITDoseService.getGeoCodeDetails(this.address).subscribe(
      (res: any) => {
        if (res.response && res.response["results"].length > 0) {
          let geoCodeDetails = res.response["results"][0].geometry;
          this.locationDetails = geoCodeDetails.location;
        } else {
          this.messageService.showErrorMessage("No data found!");
          this.locationDetails = "";
        }
        this.loadingFlag = false;
      },
      (error) => {
        this.messageService.showError();
      }
    );
  }

  loadBasicDetailsOfLead() {
    //debugger
    if (this.selectedUHIDDetails.firstName) {
      this.createAppointmentForm.controls["patientFirstName"].setValue(
        this.selectedUHIDDetails.firstName
      );
      //this.createAppointmentForm.controls["patientFirstName"].disable();
    }
    if (this.selectedUHIDDetails.lastName) {
      this.createAppointmentForm.controls["patientLastName"].setValue(
        this.selectedUHIDDetails.lastName
      );
      //this.createAppointmentForm.controls["patientLastName"].disable();
    }
    if (
      (this.selectedUHIDDetails["gender"] &&
        this.selectedUHIDDetails["gender"].toLowerCase() == "male") ||
      this.selectedUHIDDetails["gender"].toLowerCase() == "female"
    ) {
      this.createAppointmentForm.controls.gender.setValue(
        this.selectedUHIDDetails["gender"].toLowerCase() == "male" ? "1" : "2"
      );
      //this.createAppointmentForm.controls["gender"].disable();
    }
    if (this.selectedUHIDDetails.emailId) {
      this.createAppointmentForm.controls["email"].setValue(
        this.selectedUHIDDetails.emailId
      );
      //this.createAppointmentForm.controls["email"].disable();
    }
    if (this.selectedUHIDDetails.phoneNo) {
      this.createAppointmentForm.controls["patientMobileNumber"].setValue(
        this.selectedUHIDDetails.phoneNo
      );
      this.createAppointmentForm.controls["mobileNumber"].setValue(
        this.selectedUHIDDetails.phoneNo
      );
      //this.createAppointmentForm.controls["patientMobileNumber"].disable();
    }
    this.getAllCities(this.selectedAppointmentType);
  }

  loadBasicDetails() {
    if (this.selectedUHIDDetails.firstName) {
      this.createAppointmentForm.controls["patientFirstName"].setValue(
        this.selectedUHIDDetails.firstName
      );
      this.createAppointmentForm.controls["patientFirstName"].disable();
    }
    if (this.selectedUHIDDetails.lastName) {
      this.createAppointmentForm.controls["patientLastName"].setValue(
        this.selectedUHIDDetails.lastName
      );
      this.createAppointmentForm.controls["patientLastName"].disable();
    }
    if (
      this.selectedUHIDDetails.gender == 1 ||
      this.selectedUHIDDetails.gender == 2
    ) {
      this.createAppointmentForm.controls.gender.setValue(
        this.selectedUHIDDetails.gender + ""
      );
      this.createAppointmentForm.controls["gender"].disable();
    }

    if (this.selectedUHIDDetails.dateOfBirth) {
      let dob = this.selectedUHIDDetails.dateOfBirth.split("/");
      this.createAppointmentForm.controls["dateOfBirth"].setValue(
        new Date(dob[2], dob[1] - 1, dob[0])
      );
      this.createAppointmentForm.controls["dateOfBirth"].disable();
    }
    if (this.selectedUHIDDetails.maritalStatus != 0) {
      this.createAppointmentForm.controls["maritalStatusId"].setValue(
        this.selectedUHIDDetails.maritalStatus
      );
      this.createAppointmentForm.controls["maritalStatusId"].disable();
    }
    if (this.selectedUHIDDetails.salutation != 0) {
      this.createAppointmentForm.controls["salutation"].setValue(
        this.selectedUHIDDetails.salutation
      );
      this.createAppointmentForm.controls["salutation"].disable();
    }
    if (this.selectedUHIDDetails.emailId) {
      this.createAppointmentForm.controls["email"].setValue(
        this.selectedUHIDDetails.emailId
      );
      this.createAppointmentForm.controls["email"].disable();
    }
    if (
      this.selectedUHIDDetails.phoneNo ||
      this.selectedUHIDDetails.mobileNumber
    ) {
      this.createAppointmentForm.controls["patientMobileNumber"].setValue(
        this.isNewUser
          ? this.selectedUHIDDetails.phoneNo
          : this.selectedUHIDDetails.mobileNumber
      );
      this.createAppointmentForm.controls["mobileNumber"].setValue(
        this.isNewUser
          ? this.selectedUHIDDetails.phoneNo
          : this.selectedUHIDDetails.mobileNumber
      );
      this.createAppointmentForm.controls["patientMobileNumber"].disable();
    }
  }

  CityByName(index, item) {
    return item.name;
  }

  /* getAreaPincode(){
    this.callCenterService.getAllAreaPincode().subscribe((res: any) =>{
      if(res && res.response.length > 0){
         let rawAreaCode = res.response;
        //console.log(this.areaCode,"Pincode")
      let idModified = rawAreaCode.map(
          obj => {
              return {
                  "label" : obj.area,
                  "city": obj.city,
                  "country": obj.country,
                  "id": obj.id,
                  "value": obj.pincode,
                  "state": obj.state
              }
          }
      );
      this.areaCode = idModified;
      this.areaCode.unshift({ label: 'Select Area ',city : "", country: "", id: "", value: "", state: "" });
      //console.log(this.areaCode, "test");  

      }
    },
    (error) => {
      this.messageService.showErrorMessage(
        "Unable to retrieve Area Pincode data from server "
      );
    }
    )
  } */

  getAllCities(apptType) {
    this.citiesData = [];
    this.disableOrEnableForm(0);

    if (this.currentUserBU !== "Dialysis") {
      this.askApolloService
        .getAllCities(apptType, this.selectedHospitalType)
        .subscribe(
          (res: any) => {
            const integrationValue =
              this.askApolloService.getIntegrationValueFromLocalStorage();

            // if (integrationValue == "2") {
            //   if (res && res.response && res.response.citiesList) {
            //     this.citiesData = res.response.citiesList.map((city) => ({
            //       city_id: city.city_id,
            //       name: city.name,
            //     }));
            //   }
            // } else {
            if (res && res.response && res.response.citiesList) {
              this.citiesData = res.response.citiesList.map((city) => ({
                id: city.id != null ? city.id : city.city_id,
                name: city.name,
              }));
            }
            //}
            console.log("citiesdata", this.citiesData);
            // this.disableOrEnableForm(1);
          },
          (error) => {
            this.messageService.showErrorMessage(
              "Unable to retrieve cities data from server."
            );
            this.disableOrEnableForm(1);
          }
        );
    } else {
      this.callCenterService.getDialysisCities().subscribe(
        (res) => {
          if (res && res.response && res.response.length > 0) {
            this.citiesData = res.response.map((obj) => ({
              id: obj.id,
              name: obj.cityName,
            }));
          }
        },
        (error) => {
          this.messageService.showError();
        }
      );
    }
  }

  onCityChange(event: any) {
    const cityId = event.target.value;
    ["createAppointmentForm", "callStatusForm"].forEach((formName) => {
      if (this[formName] && this[formName].get("city")) {
        this[formName].get("city").setValue(cityId);
      }
    });
    this.getClinicsOnCityId(cityId);
  }

  ClinicByName(index, item) {
    return item.name;
  }

  getClinicsOnCityId(cityId) {
    this.clinicsData = [];
    this.specialitiesData = [];
    this.doctorsData = [];
    this.slotsData = [];
    this.datesData = [];
    this.invalidApptDates = [];
    this.apptMinimumDate = new Date(1900, 0, 1); // Jan 1, 1900
    this.apptMaximumDate = new Date(2100, 11, 31); // Dec 31, 2100
    this.createAppointmentForm.get("clinic").setValue("");
    this.createAppointmentForm.get("clinic").markAsPristine();
    this.createAppointmentForm.get("clinic").markAsUntouched();
    this.createAppointmentForm.get("speciality").setValue("");
    this.createAppointmentForm.get("doctor").setValue("");
    this.createAppointmentForm.get("appointmentDate").setValue("");
    this.createAppointmentForm.get("appointmentSlot").setValue("");
    this.selectedDoctor = -1;
    if (
      cityId &&
      this.currentUserBU != "Diagnostics" &&
      this.currentUserBU != "Dialysis"
    ) {
      this.selectedCity = cityId;
      this.disableOrEnableForm(0);
      this.askApolloService
        .getClinicsOnCityId(
          this.selectedAppointmentType,
          this.selectedHospitalType,
          cityId
        )
        .subscribe(
          // appttype, hospitaltype, cityid
          (res: any) => {
            debugger;
            // console.log("Hospitals:", res);
            //  if (
            //   res &&
            //   res.response &&
            //   res.response.hospitalList &&
            //   res.response.hospitalList.length > 0 &&
            //   this.selectedCallStatusId == "15"
            // )
            const integrationValue =
              this.askApolloService.getIntegrationValueFromLocalStorage();

            if (integrationValue == "2") {
              if (res && this.selectedCallStatusId == "15") {
                // this.clinicsData = res.response.hospitalList;
                this.clinicsData = res.response.result.hospitalList;
                this.clinicsData = this.clinicsData.filter((d) => {
                  if (d.name != "Not Mentioned") {
                    return true;
                  }
                });
              } else if (res && res.response.result.hospitalList.length > 0) {
                //this.clinicsData = res.response.hospitalList;
                this.clinicsData = res.response.result.hospitalList;
              } else if (this.clinicsData.length === 0) {
                this.messageService.showErrorMessage(
                  "No clinics available for selected city."
                );
              }
            } else {
              if (res && this.selectedCallStatusId == "15") {
                // this.clinicsData = res.response.hospitalList;
                this.clinicsData = res;
                this.clinicsData = this.clinicsData.filter((d) => {
                  if (d.name != "Not Mentioned") {
                    return true;
                  }
                });
              } else if (
                res &&
                res.response &&
                res.response.result.hospitalList &&
                res.response.result.hospitalList.length > 0
              ) {
                this.clinicsData = res.response.result.hospitalList
                  .filter(function (d) {
                    return d.name && d.name.trim() !== "";
                  })
                  .map(function (d) {
                    return { id: d.id, name: d.name };
                  });
                console.log("ClinicsData Final: ", this.clinicsData);
              } else if (this.clinicsData.length === 0) {
                this.messageService.showErrorMessage(
                  "No clinics available for selected city."
                );
              }
            }

            this.disableOrEnableForm(1);
          },
          (error) => {
            // this.messageService.showError();
            this.messageService.showErrorMessage(
              "No clinics available for selected city. Please Contact Admin."
            );
            this.disableOrEnableForm(1);
          }
        );
    } else {
      if (cityId == -1) {
        this.clinicsData = [{ id: -1, name: "Not Mentioned" }];
      } else {
        this.callCenterService
          .getDialysisClinicsCityWise(parseInt(cityId))
          .subscribe(
            (res: any) => {
              this.loadingFlag = false;
              if (res && res.response && res.response.length > 0) {
                let rawAreaCode = res.response;
                let idModified = rawAreaCode.map((obj) => {
                  return {
                    id: obj.autoId,
                    name: obj.clinicName,
                  };
                });
                this.clinicsData = idModified;
                this.clinicsData.push({ id: -1, name: "Not Mentioned" });
              }
              console.log(this.clinicsData, "Dialysis");
            },
            (error) => {
              this.loadingFlag = false;
              this.messageService.showError();
            }
          );
      }
    }
  }

  specialitiesByName(index, item) {
    return item.name;
  }
  getAppointmentType(selectedappointmentTypeId) {
    this.appointmentTypeId = selectedappointmentTypeId;
  }

  getSpecialities(hospitalId) {
    this.specialitiesData = [];
    this.doctorsData = [];
    this.slotsData = [];
    this.datesData = [];
    this.invalidApptDates = [];
    this.apptMinimumDate = new Date(1900, 0, 1); // Jan 1, 1900
    this.apptMaximumDate = new Date(2100, 11, 31); // Dec 31, 2100
    this.selectedDoctor = -1;
    this.createAppointmentForm.get("speciality").setValue("");
    //this.createAppointmentForm.get("appointmentDate").setValue("");
    this.createAppointmentForm.get("doctor").setValue("");
    this.createAppointmentForm.get("appointmentSlot").setValue("");
    if (hospitalId && this.currentUserBU != "Dialysis") {
      this.disableOrEnableForm(0);
      this.selectedHospital = hospitalId;
      this.askApolloService
        .getSpecialitiesOnHospitalId(this.selectedHospitalType, hospitalId) // hospitaltype, hospitalid
        .subscribe(
          (res: any) => {
            //console.log("spec:", res);
            const integrationValue =
              this.askApolloService.getIntegrationValueFromLocalStorage();

            if (integrationValue == "2") {
              this.specialitiesData = res.response.specilaityList;
            } else {
              if (res) {
                this.specialitiesData = res.response.specilaityList;
              } else {
                this.doctorsData = [];
                this.datesData = [];
                this.slotsData = [];
                this.messageService.showErrorMessage(
                  "No speciality available for selected clinic."
                );
              }
            }
            this.disableOrEnableForm(1);
          },
          (error) => {
            // this.messageService.showError();
            this.messageService.showErrorMessage(
              "No speciality available for selected clinic. Please Contact Admin."
            );
            this.disableOrEnableForm(1);
          }
        );
    } else {
      this.loadingFlag = false;
      // let tempspeciality = <specialityData>{};
      // tempspeciality.id = -2,-1;
      // tempspeciality.name = "Dialysis", "Not Mentioned";
      //this.specialitiesData.push(tempspeciality);
      this.specialitiesData = [
        { id: -2, name: "Dialysis" },
        { id: -1, name: "Not Mentioned" },
      ];
    }
  }

  DoctorByName(index, item) {
    return item.name;
  }

  getDoctors(specialityId) {
    // debugger;
    this.doctorsData = [];
    this.datesData = [];
    this.slotsData = [];
    this.invalidApptDates = [];
    this.apptMinimumDate = new Date(1900, 0, 1); // Jan 1, 1900
    this.apptMaximumDate = new Date(2100, 11, 31); // Dec 31, 2100
    // this.createAppointmentForm.get("appointmentDate").setValue("");
    this.createAppointmentForm.get("appointmentSlot").setValue("");
    this.createAppointmentForm.get("doctor").setValue("");
    this.selectedDoctor = -1;
    if (specialityId) {
      this.disableOrEnableForm(0);
      this.selectedSpeciality = specialityId;
      if (specialityId == -1 || specialityId == -2) {
        this.doctorsData = [{ DoctorId: -1, DoctorName: "Not Mentioned" }];
        this.disableOrEnableForm(1);
        this.ref.detectChanges();
      } else {
        this.askApolloService
          .getDoctorsOnSpeciality(this.selectedHospital, specialityId) // hospitalid, specId
          .subscribe(
            (res: any) => {
              debugger;
              const integrationValue =
                this.askApolloService.getIntegrationValueFromLocalStorage();

              if (integrationValue == "2") {
                this.doctorsData = res.response;
              } else {
                if (res) {
                  this.doctorsData = res.response;
                }
              }

              console.log("doctors:", res);
              // if (res.response.length > 0) {
              //   this.doctorsData = res.response;
              // } else {
              //   this.messageService.showErrorMessage(
              //     "No doctors available for selected speciality."
              //   );
              // }
              this.disableOrEnableForm(1);
              this.ref.detectChanges();
            },
            (error) => {
              // this.messageService.showError();
              this.messageService.showErrorMessage(
                "No doctors available on selected speciality. Please Contact Admin."
              );
              this.disableOrEnableForm(1);
            }
          );
      }
    }
  }
  isNoDatesAvailable = true;
  getDates(doctorId) {
    this.slotsData = [];
    this.datesData = [];
    this.invalidApptDates = [];
    this.apptMinimumDate = new Date(1900, 0, 1); // Jan 1, 1900
    this.apptMaximumDate = new Date(2100, 11, 31); // Dec 31, 2100

    // this.createAppointmentForm.get("appointmentDate").setValue("");
    this.createAppointmentForm.get("appointmentSlot").setValue("");
    this.createAppointmentForm.get("appointmentDate").setValue("");
    this.selectedDoctor = -1;
    if (doctorId) {
      this.disableOrEnableForm(0);
      this.datesData = [];
      this.selectedDoctor = doctorId;
      this.askApolloService
        .getDates(this.selectedHospital, doctorId) // hospitalid, doctorId
        .subscribe(
          (res: any) => {
            debugger;
            const integrationValue =
              this.askApolloService.getIntegrationValueFromLocalStorage();

            // if (integrationValue == "2") {
            //   if (res) {
            //     this.datesData = res.response;
            //     if (res.response.name != null) {
            //       this.isNoDatesAvailable = false;
            //       this.disableApptDates(res.response.name);
            //     } else {
            //       this.isNoDatesAvailable = true;
            //       this.datesData = [];
            //       this.slotsData = [];
            //       this.invalidApptDates = [];
            //       if (this.datesData.length === 0) {
            //         this.messageService.showErrorMessage(
            //           "No dates available for selected doctor."
            //         );
            //       }
            //     }
            //   }
            // }
            //  else
            // {
            if (res) {
              this.datesData = res.response;
              if (res.response.name != null) {
                this.isNoDatesAvailable = false;
                this.disableApptDates(res.response.name);
              } else {
                this.isNoDatesAvailable = true;
                this.datesData = [];
                this.slotsData = [];
                this.invalidApptDates = [];
                if (this.datesData.length === 0) {
                  this.messageService.showErrorMessage(
                    "No dates available for selected doctor."
                  );
                }
              }
              //}
            }
            // if (res) {
            //   this.datesData = res.response;
            //   if (res.response.name != null) {
            //     this.isNoDatesAvailable = false;
            //     this.disableApptDates(res.response.name);
            //   } else {
            //     this.isNoDatesAvailable = true;
            //     this.datesData = [];
            //     this.slotsData = [];
            //     this.invalidApptDates = [];
            //     if (this.datesData.length === 0) {
            //       this.messageService.showErrorMessage(
            //         "No dates available for selected doctor."
            //       );
            //     }
            //   }
            // }
            this.ref.detectChanges();
            this.disableOrEnableForm(1);
          },
          (error) => {
            // this.messageService.showError();
            this.messageService.showErrorMessage(
              "No dates available for selected doctor. Please Contact Admin."
            );
            this.disableOrEnableForm(1);
          }
        );
    }
  }

  apptMaximumDate = new Date();
  apptMinimumDate = new Date();
  invalidApptDates: Date[];
  tempDates: Date[];
  disableApptDates(enableDates) {
    //enableDates = "2020-5-14,2020-5-18,2020-5-19,2020-5-20,2020-5-21,2020-5-25,2020-5-26,2020-5-27,2020-5-30,2020-6-1,2020-6-2,2020-6-3,2020-6-4,2020-6-5,2020-6-6,2020-6-11,2020-6-12,2020-6-13,2020-6-15,2020-6-16,2020-6-19,2020-6-20,2020-6-22,2020-6-23,2020-6-24,2020-6-25,2020-6-26,2020-6-27,2020-6-29,2020-6-30,2020-7-1,2020-7-2,2020-7-3,2020-7-4,2020-7-6,2020-7-7,2020-7-8,2020-7-9,2020-7-10,2020-7-11,2020-7-13,2020-7-14,2020-7-15,2020-7-16,2020-7-17,2020-7-18,2020-7-20,2020-7-21,2020-7-22,2020-7-23,2020-7-24,2020-7-25,2020-7-27,2020-7-28,2020-7-29,2020-7-30,2020-7-31,2020-8-1,2020-8-3,2020-8-4,2020-8-5,2020-8-6,2020-8-7,2020-8-8,2020-8-14,2020-8-15,2020-8-17,2020-8-18,2020-8-19,2020-8-20,2020-8-21,2020-8-22,2020-8-24,2020-8-29,2020-8-31";
    this.invalidApptDates = [];
    this.apptMinimumDate = new Date(1900, 0, 1); // Jan 1, 1900
    this.apptMaximumDate = new Date(2100, 11, 31); // Dec 31, 2100
    this.datesData = enableDates ? enableDates.split(",") : [];
    if (this.datesData.length > 0) {
      this.datesData.sort(
        (a, b) => new Date(a).getTime() - new Date(b).getTime()
      );
      this.apptMaximumDate = new Date(
        this.parseDateFromDDMMYYYY(this.datesData[this.datesData.length - 1])
      );
      this.apptMinimumDate = new Date(
        this.parseDateFromDDMMYYYY(this.datesData[0])
      );
      this.tempDates = [];
      this.datesData.forEach((d) => {
        this.tempDates.push(new Date(d));
      });
      this.invalidApptDates = this.calendarService.getDisabledDates(
        this.tempDates
      );
      this.ref.detectChanges();
    } else {
      this.invalidApptDates = [];
      if (this.datesData.length === 0) {
        this.messageService.showErrorMessage(
          "No dates available for selected doctor."
        );
      }
    }
  }

  parseDateString(dateStr: string): Date {
    const [day, month, year] = dateStr.split("/").map(Number);
    return new Date(year, month - 1, day); // Month is 0-indexed
  }

  SlotsByName(index, item) {
    return item.slotTime;
  }

  allSlotsData = [];
  selectedAppointmentDate = "";
  getSlots(apptDate) {
    this.allSlotsData = [];
    let dd = new Date(apptDate);
    let date = dd.getDate() + "";
    let month = dd.getMonth() + 1 + "";
    let year = dd.getFullYear();
    apptDate =
      year +
      "-" +
      (month.length == 1 ? "0" + month : month) +
      "-" +
      (date.length == 1 ? "0" + date : date);
    this.selectedAppointmentDate = apptDate;
    if (apptDate) {
      this.disableOrEnableForm(0);
      this.askApolloService
        .getSlots(
          this.selectedHospital,
          this.selectedDoctor,
          this.selectedAppointmentDate,
          apptDate,
          this.selectedSpeciality
        )
        .subscribe(
          (res: any) => {
            const integrationValue =
              this.askApolloService.getIntegrationValueFromLocalStorage();

            // if (integrationValue == "2") {

            //   this.slotsData = res.response;
            //   this.allSlotsData = [];

            //   const morningSlots = [];
            //   const afternoonSlots = [];
            //   const eveningSlots = [];
            //   const nightSlots = [];

            //   res.response.forEach((slot) => {
            //     const hour = parseInt(slot.timeSlot.split(":")[0], 10);

            //     if (hour >= 6 && hour < 12) {
            //       morningSlots.push(slot);
            //     } else if (hour >= 12 && hour < 16) {
            //       afternoonSlots.push(slot);
            //     } else if (hour >= 16 && hour < 20) {
            //       eveningSlots.push(slot);
            //     } else {
            //       nightSlots.push(slot);
            //     }
            //   });

            //   // Merge all slots into one array if needed
            //   this.allSlotsData = [
            //     ...morningSlots,
            //     ...afternoonSlots,
            //     ...eveningSlots,
            //     ...nightSlots,
            //   ];

            //   // Optional: store separately for tabbing or UI
            //   this.slotsData = {
            //     morningSlotTime: morningSlots,
            //     afternoonSlotTime: afternoonSlots,
            //     eveningSlotTime: eveningSlots,
            //     nightSlottTime: nightSlots,
            //   };

            //   if (this.allSlotsData.length === 0) {
            //     this.messageService.showErrorMessage(
            //       "No slots available on selected date."
            //     );
            //   }
            // } else
            {
              debugger;
              this.slotsData = res.response;

              if (
                this.slotsData["morningSlotTime"] &&
                this.slotsData["morningSlotTime"].length > 0
              ) {
                this.allSlotsData = this.allSlotsData.concat(
                  this.slotsData["morningSlotTime"]
                );
              }
              if (
                this.slotsData["afternoonSlotTime"] &&
                this.slotsData["afternoonSlotTime"].length > 0
              ) {
                this.allSlotsData = this.allSlotsData.concat(
                  this.slotsData["afternoonSlotTime"]
                );
              }
              if (
                this.slotsData["eveningSlotTime"] &&
                this.slotsData["eveningSlotTime"].length > 0
              ) {
                this.allSlotsData = this.allSlotsData.concat(
                  this.slotsData["eveningSlotTime"]
                );
              }
              if (
                this.slotsData["nightSlottTime"] &&
                this.slotsData["nightSlottTime"].length > 0
              ) {
                this.allSlotsData = this.allSlotsData.concat(
                  this.slotsData["nightSlottTime"]
                );
              }

              if (this.allSlotsData.length <= 0) {
                this.slotsData = res.response;
                this.allSlotsData = [];

                const morningSlots = [];
                const afternoonSlots = [];
                const eveningSlots = [];
                const nightSlots = [];

                res.response.forEach((slot) => {
                  const hour = parseInt(slot.timeSlot.split(":")[0], 10);

                  if (hour >= 6 && hour < 12) {
                    morningSlots.push(slot);
                  } else if (hour >= 12 && hour < 16) {
                    afternoonSlots.push(slot);
                  } else if (hour >= 16 && hour < 20) {
                    eveningSlots.push(slot);
                  } else {
                    nightSlots.push(slot);
                  }
                });

                // Merge all slots into one array if needed
                this.allSlotsData = [
                  ...morningSlots,
                  ...afternoonSlots,
                  ...eveningSlots,
                  ...nightSlots,
                ];

                // Optional: store separately for tabbing or UI
                this.slotsData = {
                  morningSlotTime: morningSlots,
                  afternoonSlotTime: afternoonSlots,
                  eveningSlotTime: eveningSlots,
                  nightSlottTime: nightSlots,
                };

                if (this.allSlotsData.length === 0) {
                  this.messageService.showErrorMessage(
                    "No slots available on selected date."
                  );
                }
              }
              //this.getSlotsObject(res.response);
              // console.log("slots:", thi
            }

            this.disableOrEnableForm(1);
          },
          (error) => {
            this.messageService.showErrorMessage(
              "No slots available on selected date. Please Contact Admin."
            );
            this.disableOrEnableForm(1);
          }
        );
    }
  }

  slotsChangeEvent(ee) {
    console.log(JSON.stringify(ee.target.value));
  }

  ApptsModesByName(index, item) {
    return item.name;
  }

  getApptRequestModes() {
    debugger;
    this.disableOrEnableForm(0);
    this.apptRequestModes = [];
    this.callCenterService.getApptRequestModes().subscribe(
      (res: any) => {
        // this.apptRequestModes = res.response;
        console.log("dates:", res);
        if (res.response.length > 0) {
          this.apptRequestModes = res.response;
        }
        this.disableOrEnableForm(1);
      },
      (error) => {
        this.messageService.showErrorMessage(
          "Unable to retrieve Appt Requests data from server "
        );
        this.disableOrEnableForm(1);
      }
    );
  }

  leadSources: any = [];
  getAllLeadSources() {
    this.commonService.getAllLeadSources().subscribe(
      (res: any) => {
        if (res.response.length > 0) {
          // this.leadSources = res.response;
          this.apptRequestModes = res.response;
        } else {
          this.apptRequestModes = [];
          this.disableOrEnableForm(1);
        }
      },
      (error) => {
        this.messageService.showErrorMessage(
          "Unable to retrieve leadsource data from server "
        );
        this.disableOrEnableForm(1);
      }
    );
  }

  bookAppointment(formData) {
    // alert("create app");
    // console.log("Form Data:", this.createAppointmentForm.value);
    if (this.createAppointmentForm.invalid) {
      // If form is invalid, return without submitting
      this.messageService.showErrorMessage(
        "Please correct the errors in the form."
      );
      return;
    }

    debugger;
    if (this.createAppointmentForm.valid) {
      this.createAppointmentForm.enable();
      this.disableOrEnableForm(0);
      let formDataValues = this.createAppointmentForm.value;
      let slotObj = this.allSlotsData.find(
        (o) => o.slotId == formDataValues.appointmentSlot
      );
      let uhidNumber = "";
      if (localStorage.getItem("SelectedUHIDNumber")) {
        uhidNumber = localStorage.getItem("SelectedUHIDNumber");
      }
      // let payload = {
      //   Leadsource: "AHLL-CRM", //this.selectedUHIDDetails["utm_source"] ? this.selectedUHIDDetails["utm_source"] : "AHLL-CRM",//"AngularAdmin-PhysicalAppointment",
      //   CRMLeadSource: formDataValues.appointmentReqMode,
      //   CityId: +formDataValues.city,
      //   PatientAreaName: this.selectedArea,
      //   PatientAreaPincode: this.selectedAreaPincode,
      //   AppointmentDate: CommonMethods.changeDateFormatDDMMYYYY(formDataValues.appointmentDate),
      //   SlotId: slotObj.slotId,
      //   SlotTime: slotObj.slotTime,
      //   RelationTypeId: +formDataValues.relationTypeId,
      //   CountryCode: "91",
      //   PatientFirstName: formDataValues.patientFirstName,
      //   PatientLastName: formDataValues.patientLastName,
      //   PatientEmailId: formDataValues.email,
      //   DateOfBirth: CommonMethods.changeDateFormatDDMMYYYY(formDataValues.dateOfBirth), //format yyyy/mm/dd
      //   Gender: +formDataValues.gender,
      //   PatientMobileNo: formDataValues.patientMobileNumber, //mobileNumber
      //  // PatientUHID: this.selectedUHIDDetails.uhidNumber,
      //  PatientUHID: 122,
      //   IpAddress: "",
      //   AppointmentBookingToken: this.slotsData["appointmentBookingToken"],
      //   SpecialtyId: +formDataValues.speciality,
      //   DoctorId: +formDataValues.doctor,
      //   HospitalId: +formDataValues.clinic,
      //   CreatedIp: null,
      //   CreatedBy: 0,
      //   ContactId: 0,
      //   LeadAutoId: this.leadId,
      //   AppointmentRequestModeId: 0, //+formDataValues.appointmentReqMode,
      //   CallerAutoId: +this.callerStatusAutoId,
      //   CallerId: this.callerId,
      //   CallStatusId: +this.selectedCallStatusId,
      //   StatusRemarks: formDataValues.statusRemarks,
      //   IsActivityLead:
      //     localStorage.getItem("IsActivityLead") == "true" ? true : false,
      // };
      let leadData = JSON.parse(
        localStorage.getItem("CurrentOutBoundCallMobileNumber")
      );
      var options = this.doctorsData.filter(
        (doctor) => doctor.doctorId === formDataValues.doctor.toString()
      );

      var appointmentToken =
        slotObj !== undefined ? slotObj.appointmentBookToken : "quadone";
      var optionsSpeciality = this.specialitiesData.filter(
        (speciality) => speciality.id === formDataValues.speciality.toString()
      );
      var optionHospitals = this.clinicsData.filter(
        (clinic) => clinic.id.toString() === formDataValues.clinic.toString()
      );
      var HospitalNameText =
        optionHospitals.length > 0 ? optionHospitals[0].name : "";
      debugger;
      var DoctorNameText = options.length > 0 ? options[0].doctorName : "";
      var SpecialityNameText =
        optionsSpeciality.length > 0 ? optionsSpeciality[0].name : "";
      console.log("HospitalNameText", HospitalNameText);

      console.log("DoctorNameText", DoctorNameText);
      let payload = {
        leadsource: "AHLL-CRM",
        CrmLeadSource: formDataValues.appointmentReqMode,
        cityId: formDataValues.city.toString(),
        slotId: slotObj.slotId,
        slotTime:
          this.IsThirdPartyIntegration === "2" ||  this.IsThirdPartyIntegration === "4"
            ? slotObj.timeSlot
            : slotObj.slotTime,
        appointmentDate: CommonMethods.changeDateFormatDDMMYYYY(
          formDataValues.appointmentDate
        ),
        relationTypeId: +formDataValues.relationTypeId,
        countryCode: formDataValues.countryCode,
        patientFirstName: formDataValues.patientFirstName,
        patientLastName: formDataValues.patientLastName,
        patientEmailId: formDataValues.email,
        dateOfBirth: CommonMethods.changeDateFormatDDMMYYYY(
          formDataValues.dateOfBirth
        ), //format yyyy/mm/dd
        gender: +formDataValues.gender,
        patientMobileNo: formDataValues.patientMobileNumber, //mobileNumber,
        patientUHID:
          leadData.patientUHID === undefined ||
          leadData.patientUHID === null ||
          leadData.patientUHID === ""
            ? uhidNumber
            : localStorage.getItem("SelectedUHIDNumber"),
        ipAddress: "",
        appointmentBookingToken: appointmentToken,
        specialtyId: formDataValues.speciality.toString(),
        doctorId: formDataValues.doctor.toString(),
        doctorName: DoctorNameText,
        hospitalId: +formDataValues.clinic,
        createdBy: 0,
        contactId: 0,
        appointmentRequestModeId: 0,
        leadAutoId: this.leadId,
        callerAutoId: 0,
        callStatusId: 1,
        statusRemarks: formDataValues.statusRemarks,
        isActivityLead:
          localStorage.getItem("IsActivityLead") == "true" ? true : false,
        instaPatientCategoryId: 0,
        patientAreaName: this.selectedArea,
        patientAreaPincode: this.selectedAreaPincode,
        callerId: this.callerId,
        CallerNumber: leadData ? leadData.phoneNo : formDataValues.mobileNumber,
        specialtyName: SpecialityNameText,
        hospitalName: HospitalNameText,
        isonline: this.appointmentTypeId,
      };

      debugger;
      this.askApolloService.BookConsultationAppointment(payload).subscribe(
        (res: any) => {
          debugger;
          this.loadingFlag = false;
          if (res.response["statusCode"] > 0) {
            this.messageService.showSuccess(
              "Appointment Created Successfully."
            );
          }

          // console.log("book:", res);
          if (res && res.isSuccess && res.response) {
            // this.messageService.showSuccess(
            //   "Appointment Created Successfully."
            // );
            if (res.response && res.response["statusCode"] > 0) {
              alert("Appointment Created Successfully.");

              // this.messageService.showSuccess(
              //   "Appointment Created Successfully."
              // );
              // this.messageService.showSuccess(res.response["message"]);
              this.callCenterService.afterCompleteOperationKnowTheStatus({
                callStatusId: this.selectedCallStatusId,
                callStatusName: this.selectedCallStatusName,
                isOperationDone: true,
                statusMessage: "Appointment Created Successfully.",
              });
              // this.messageService.showSuccess(
              //   "Appointment Created Successfully."
              // );

              localStorage.removeItem("AppointmentInformation");
            } else {
              this.messageService.showWarning(res.response["message"]);
            }
          } else {
            // this.messageService.showWarning(
            //   "Please Contact Admin, Server Issue !!!"
            // );
          }
          //  this.messageService.showSuccess("Appointment Created Successfully.");
          this.disableOrEnableForm(1);
        },
        (error) => {
          // this.messageService.showErrorMessage(
          //   "Unable to book appointment, An error occur while booking appointment."
          // );
          this.disableOrEnableForm(1);
        }
      );
    } else {
      // this.messageService.showWarning("Please Fill Fields");
    }
  }

  UpdateCallStatusDetails(formData) {
    let time = this.getTimeOnly(formData.callBackTime);
    let date = CommonMethods.changeDateFormatDDMMYYYY(formData.callBackDate);
    let payload = {
      AutoId: +this.callerStatusAutoId,
      CallerId: this.callerId,
      CallStatus: +this.selectedCallStatusId,
      CallSubStatus: +formData.subDisposition,
      CityId: +formData.city,
      ClinicId: +formData.clinic ? +formData.clinic : 0,
      SpecialtyId: +formData.speciality ? +formData.speciality : 0,
      DoctorId: +formData.doctor ? +formData.doctor : 0,
      Area: formData.area ? formData.area : "",
      ScheduledDate: formData.scheduleDate
        ? CommonMethods.changeDateFormatDDMMYYYY(formData.scheduleDate)
        : 0, //format yyyy/mm/dd
      Remarks: formData.remarks,
      CallbackRequestDate: date,
      CallbackRequestTime: time,
      IsActivityLead:
        localStorage.getItem("IsActivityLead") == "true" ? true : false,
    };
    this.disableOrEnableForm(0);
    let leadData1 = JSON.parse(
      localStorage.getItem("CurrentInBoundCallDetails")
    );
    debugger;
    let payload1 = {
      agentNumber: "8128987151",
      ownerId: "23481",
      leadId: "1",
      CallerNumber: leadData1.patientMobileNumber.replace(/^\+91/, ""),
    };
    this.commonService.callEnd(payload1).subscribe((result) => {
      debugger;
      if (result !== null) {
        this.messageService.showSuccess("Call ended");
      }
    });
    this.callCenterService.UpdateCallStatusDetails(payload).subscribe(
      (res: any) => {
        this.messageService.showSuccess(res.response["statusMessage"]);
        this.callCenterService.afterCompleteOperationKnowTheStatus({
          callStatusId: this.selectedCallStatusId,
          callStatusName: this.selectedCallStatusName,
          isOperationDone: true,
          statusMessage: this.selectedCallStatusName + " Status Updated.",
        });
        this.disableOrEnableForm(1);
      },
      (error) => {
        this.messageService.showErrorMessage(
          "Unable to update call details, An error occur while updating call details."
        );
        this.disableOrEnableForm(1);
      }
    );
  }

  disableOrEnableForm(flag) {
    debugger;
    // 1 enable , 0 disable
    if (flag == 1) {
      this.loadingFlag = false;
      //this.ref.detectChanges();
      //this.createAppointmentForm.enable();
    } else {
      this.loadingFlag = true;
      //this.createAppointmentForm.disable();
    }
  }
  // controls validation
  public hasError = (controlName: string, errorName: string) => {
    return this.createAppointmentForm.controls[controlName].hasError(errorName);
  };

  appendZeroWhenSingleDigitInTime(i) {
    if (i < 10) {
      i = "0" + i;
    }
    return i;
  }

  getTimeOnly(givenDate) {
    var today = new Date(givenDate);
    var h = today.getHours();
    var m = today.getMinutes();
    var s = today.getSeconds();
    // add a zero in front of numbers<10
    m = this.appendZeroWhenSingleDigitInTime(m);
    s = this.appendZeroWhenSingleDigitInTime(s);
    return h + ":" + m + ":" + s;
  }
}
